<template>
  <div class="mapAlign"
       style="height:100%;">
    {{source}}
    <toolBar  @handleReplaceImg="handleReplaceImg"
              @handleDownloadPanorama="handleDownloadPanorama"
              @hiddenModel="hiddenModel"></toolBar>
    <Panoramic ref="panoramic"
               v-if="show"
               :isHiddenMode="isHiddenMode"
               :panorama-images="panoramaImages"/>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import Panoramic from '@/components/mapComponents/panoramic.vue';
import toolBar from '@/components/mapComponents/toolBar.vue';
import { uploadMap, uploadPanorama } from '@/api/map';

export default {
  components: { toolBar, Panoramic },
  provide() {
    return {
      reload: this.reload,
    };
  },
  computed: {
    ...mapGetters(['floorInfo']),
    source() {
      return this.$route.params.source;
    },
  },
  data() {
    return {
      num: 0,
      panoramaImages: [],
      isHiddenMode: false,
      show: false,
    };
  },
  mounted() {
    this.show = ['live', 'navigation'].includes(this.source);
  },
  methods: {
    async handleReplaceImg(val) {
      // const { data: { data } } = await uploadMap('ZvS3rR6u02LBa334', val);
      const { data: { data } } = await uploadMap(this.$route.query.floor_id, val);
      const params = {
        image_url: data[0].url,
        floor_id: this.$route.query.floor_id,
        // floor_code: 'ZvS3rR6u02LBa334',
        panorama_id: this.$refs.panoramic.handlePid,
        seq_id: this.$refs.panoramic.handleSeqId,
      };
      await uploadPanorama(params).then((res) => {
        this.panoramaImages = res.data.data.panorama_images_low;
      });
    },
    handleDownloadPanorama() {
      window.open(`http://192.168.90.101:8888/admin/download-panorama?floor_id=${this.$route.query.floor_id}&panorama_id=${this.$refs.panoramic.handlePid}&seq_id=${this.$refs.panoramic.handleSeqId}`);
    },
    hiddenModel() {
      // if (!this.$refs.panoramic.panoramicShow) return;
      // if (this.num % 2) {
      //   this.$refs.panoramic.enlargeView();
      // } else {
      //   this.$refs.panoramic.shrink();
      // }
      this.isHiddenMode = !this.isHiddenMode;
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    '$route.query.floor_id': function (val) {
      this.createImg(this.floorInfo[1].floor_cmap);
    },
    source(val) {
      console.log(val);
      this.show = false;
      this.$nextTick(() => {
        this.show = ['live', 'navigation'].includes(this.source);
      });
    },
  },
};
</script>
<style lang='less' scoped>
.mapAlign{
  background: #1b1b1b;
}
</style>
